// Minha empresa (`/api/minha-empresa`): sempre a empresa da sessão.

export async function lerMinhaEmpresa(request) {
  return request("/api/minha-empresa");
}

export async function salvarMinhaEmpresa(request, dados) {
  return request("/api/minha-empresa", { method: "PATCH", body: JSON.stringify(dados), silentError: true });
}

export async function listarLocais(request, { ativos = false } = {}) {
  return request(`/api/minha-empresa/locais${ativos ? "?ativos=1" : ""}`);
}

export async function criarLocal(request, dados) {
  return request("/api/minha-empresa/locais", { method: "POST", body: JSON.stringify(dados), silentError: true });
}

export async function salvarLocal(request, id, dados) {
  return request(`/api/minha-empresa/locais/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
    silentError: true,
  });
}

export const TIPOS_LOCAL = [
  { valor: "FABRICA", rotulo: "Fábrica" },
  { valor: "SHOWROOM", rotulo: "Showroom" },
  { valor: "DEPOSITO", rotulo: "Depósito" },
  { valor: "ESCRITORIO", rotulo: "Escritório" },
  { valor: "OUTRO", rotulo: "Outro" },
];
